import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Star, MapPin, CheckCircle } from 'lucide-react';

const BookingHeader = ({ serviceId, service, vendor, serviceRating, serviceReviews }) => {
  return (
    <div className="mb-6 sm:mb-8">
      <Link
        to={`/services/${serviceId}`}
        className="group mb-5 inline-flex items-center gap-2 text-sm font-medium text-m-ink-muted transition-colors hover:text-m-ink"
      >
        <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" />
        Back to service
      </Link>

      <div className="space-y-4">
        <div>
          <h1 className="marketing-display-md mb-3 text-m-ink">
            Book {service?.service_name}
          </h1>

          <div className="flex flex-wrap items-center gap-3">
            <div className="flex items-center text-m-ink-muted">
              <span className="text-sm">by</span>
              <span className="ml-1.5 text-sm font-medium text-m-ink">
                {vendor?.business_name}
              </span>
            </div>

            <div className="flex items-center gap-1.5">
              <div className="flex">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    className={`h-3.5 w-3.5 ${
                      star <= Math.floor(serviceRating)
                        ? 'fill-current text-m-ink'
                        : 'text-m-border-light'
                    }`}
                  />
                ))}
              </div>
              <span className="text-sm font-medium text-m-ink">
                {typeof serviceRating === 'number' && !isNaN(serviceRating)
                  ? serviceRating.toFixed(1)
                  : '0.0'}
              </span>
              <span className="text-sm text-m-ink-muted">
                ({serviceReviews} reviews)
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 border-t border-m-border-light pt-4">
          {vendor?.is_verified && (
            <div className="inline-flex items-center gap-1.5 rounded-full border border-m-border-light bg-m-surface px-2.5 py-1 text-m-ink">
              <CheckCircle className="h-3.5 w-3.5" strokeWidth={2.5} />
              <span className="text-xs font-medium">Verified vendor</span>
            </div>
          )}
          <div className="flex items-center text-m-ink-muted">
            <MapPin className="mr-1.5 h-3.5 w-3.5 text-m-ink" />
            <span className="text-xs font-medium">
              {vendor
                ? `${vendor.city}, ${vendor.state}`
                : 'Location not available'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingHeader;
